import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const handleSum = num => {
    const arr = [];

    for (let i = 0; i < 9; i++) {
        arr.push(num % 10);

        num = Math.floor(num / 10);
    }

    return arr.reverse();
};

class Info extends React.PureComponent {
    static propTypes = {
        loading: PropTypes.bool,
        data: PropTypes.object,
    };

    state = {
        l_0: 0,
        l_1: 0,
        l_2: 0,
        r_0: 0,
        r_1: 0,
        r_2: 0,
        l_sum: 0,
        r_sum: 0,
        l_rate: 0,
        r_rate: 0,
    };

    componentDidUpdate(prevProps) {
        const {
            loading,
            data: { bidenSum, trumpSum, _bidenSumRate, _trumpSumRate },
        } = this.props;

        /* eslint-disable no-undef */
        if (!loading && loading !== prevProps.loading) {
            this.handleNumRun();

            const l = { l_sum: 0 };
            const r = { r_sum: 0 };

            TweenLite.to(l, 2, {
                l_sum: bidenSum,
                onUpdate: () => {
                    this.setState({
                        l_sum: l.l_sum.toFixed(0),
                    });
                },
            });

            TweenLite.to(r, 2, {
                r_sum: trumpSum,
                onUpdate: () => {
                    this.setState({
                        r_sum: r.r_sum.toFixed(0),
                    });
                },
            });

            const l_r = { l_rate: 0 };
            const r_r = { r_rate: 0 };

            TweenLite.to(l_r, 2, {
                l_rate: _bidenSumRate,
                onUpdate: () => {
                    this.setState({
                        l_rate: l_r.l_rate.toFixed(0),
                    });
                },
            });

            TweenLite.to(r_r, 2, {
                r_rate: _trumpSumRate,
                onUpdate: () => {
                    this.setState({
                        r_rate: r_r.r_rate.toFixed(0),
                    });
                },
            });
        }

        if (!loading && bidenSum !== prevProps.data.bidenSum) {

            this.setState({
                l_sum: bidenSum,
            });
        }

        if (!loading && trumpSum !== prevProps.data.trumpSum) {

            this.setState({
                r_sum: trumpSum,
            });
        }

        if (!loading && _bidenSumRate !== prevProps.data._bidenSumRate) {

            this.setState({
                l_rate: _bidenSumRate,
            });
        }

        if (!loading && _trumpSumRate !== prevProps.data._trumpSumRate) {

            this.setState({
                r_rate: _trumpSumRate,
            });
        }
        /* eslint-enable no-undef */
    }

    componentWillUnmount() {
        clearInterval(this.timer0);
        clearInterval(this.timer1);
        clearInterval(this.timer2);
    }

    handleNumRun = () => {
        let l_0 = 0;
        let l_1 = 0;
        let l_2 = 0;

        let r_0 = 0;
        let r_1 = 0;
        let r_2 = 0;

        this.timer0 = setInterval(() => {
            const {
                data: { bidenNum, trumpNum },
            } = this.props;

            if (l_0 !== Math.floor(bidenNum / 100) % 10) {
                this.setState(
                    {
                        l_0,
                    },
                    () => {
                        l_0 += 1;

                        if (l_0 > 9) l_0 = 0;
                    },
                );
            } else {
                this.setState(
                    {
                        l_0: Math.floor(bidenNum / 100) % 10,
                    },
                    () => {
                        l_0 = Math.floor(bidenNum / 100) % 10;
                    },
                );
            }

            if (r_0 !== Math.floor(trumpNum / 100) % 10) {
                this.setState(
                    {
                        r_0,
                    },
                    () => {
                        r_0 += 1;

                        if (r_0 > 9) r_0 = 0;
                    },
                );
            } else {
                this.setState(
                    {
                        r_0: Math.floor(trumpNum / 100) % 10,
                    },
                    () => {
                        r_0 = Math.floor(trumpNum / 100) % 10;
                    },
                );
            }
        }, 300);

        this.timer1 = setInterval(() => {
            const {
                data: { bidenNum, trumpNum },
            } = this.props;

            if (l_0 !== Math.floor(bidenNum / 100) % 10) {
                this.setState(
                    {
                        l_1,
                    },
                    () => {
                        l_1 += 1;

                        if (l_1 > 9) l_1 = 0;
                    },
                );
            } else {
                this.setState(
                    {
                        l_1: Math.floor(bidenNum / 10) % 10,
                    },
                    () => {
                        l_1 = Math.floor(bidenNum / 10) % 10;
                    },
                );
            }

            if (r_0 !== Math.floor(trumpNum / 100) % 10) {
                this.setState(
                    {
                        r_1,
                    },
                    () => {
                        r_1 += 1;

                        if (r_1 > 9) r_1 = 0;
                    },
                );
            } else {
                this.setState(
                    {
                        r_1: Math.floor(trumpNum / 10) % 10,
                    },
                    () => {
                        r_1 = Math.floor(trumpNum / 10) % 10;
                    },
                );
            }
        }, 150);

        this.timer2 = setInterval(() => {
            const {
                data: { bidenNum, trumpNum },
            } = this.props;

            if (l_1 !== Math.floor(bidenNum / 10) % 10) {
                this.setState(
                    {
                        l_2,
                    },
                    () => {
                        l_2 += 1;

                        if (l_2 > 9) l_2 = 0;
                    },
                );
            } else {
                this.setState({
                    l_2: bidenNum % 10,
                });
            }

            if (r_1 !== Math.floor(trumpNum / 10) % 10) {
                this.setState(
                    {
                        r_2,
                    },
                    () => {
                        r_2 += 1;

                        if (r_2 > 9) r_2 = 0;
                    },
                );
            } else {
                this.setState({
                    r_2: trumpNum % 10,
                });
            }
        }, 20);
    };

    getNumCard = arr => {
        return arr.map((n, index) => (
            <div key={index} className={styles.digit_set}>
                {[...Array(10).keys()].reverse().map(item => (
                    <div
                        key={item}
                        className={`${styles.digit} ${
                            n !== 0 && (n === item + 1 || (n === 9 && item === 0)) ? styles.previous : ''
                        } ${n !== 0 && n === item ? styles.active : ''}`}>
                        <div className={styles.digit_top}>
                            <span className={styles.digit_wrap}>{item}</span>
                        </div>
                        <div className={styles.shadow_top} />
                        <div className={styles.digit_bottom}>
                            <span className={styles.digit_wrap}>{item}</span>
                        </div>
                        <div className={styles.shadow_bottom} />
                    </div>
                ))}
            </div>
        ));
    };

    render() {
        const { l_0, l_1, l_2, r_0, r_1, r_2, l_sum, r_sum, l_rate, r_rate } = this.state;

        const bidenSumArr = handleSum(l_sum);
        const trumpSumArr = handleSum(r_sum);

        return (
            <div className={styles.info}>
                <div className={styles.trump_box}>
                    <div className={styles.trump_num}>{this.getNumCard([r_0, r_1, r_2])}</div>
                    <div className={styles.dr} />
                    <div className={styles.trump_sum}>
                        <span>{`${trumpSumArr[0]}${trumpSumArr[1]}${trumpSumArr[2]}`}</span>
                        <span>{`${trumpSumArr[3]}${trumpSumArr[4]}${trumpSumArr[5]}`}</span>
                        <span>{`${trumpSumArr[6]}${trumpSumArr[7]}${trumpSumArr[8]}`}</span>
                        <span />
                        <span>票</span>
                    </div>
                    <div className={styles.dr} />
                    <div className={styles.trump_rate}>
                        <span />
                        <span>(选民选票)</span>
                        <span>{r_rate}%</span>
                    </div>
                </div>
                <div className={styles.biden_box}>
                    <div className={styles.biden_num}>{this.getNumCard([l_0, l_1, l_2])}</div>
                    <div className={styles.dr} />
                    <div className={styles.biden_sum}>
                        <span>{`${bidenSumArr[0]}${bidenSumArr[1]}${bidenSumArr[2]}`}</span>
                        <span>{`${bidenSumArr[3]}${bidenSumArr[4]}${bidenSumArr[5]}`}</span>
                        <span>{`${bidenSumArr[6]}${bidenSumArr[7]}${bidenSumArr[8]}`}</span>
                        <span />
                        <span>票</span>
                    </div>
                    <div className={styles.dr} />
                    <div className={styles.biden_rate}>
                        <span />
                        <span>(选民选票)</span>
                        <span>{l_rate}%</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Info);
